/* Small pieces the views share. Kept here rather than in any one
   view so that adding a fourth view does not mean importing from a
   third -- views stay siblings that know about nothing but the
   registry. */

import moment from 'moment';

/** A populated relation array -> "A, B, C". */
export const names = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return '—';
  const list = arr.map((x) => x?.name).filter(Boolean);
  return list.length ? list.join(', ') : '—';
};

/** "monday,tuesday,thursday" -> "Mon, Tue, Thu". */
export const formatDays = (days) => {
  const list = String(days || '')
    .split(',')
    .map((d) => d.trim())
    .filter(Boolean);
  if (list.length === 0) return '—';
  return list
    .map((d) => d.charAt(0).toUpperCase() + d.slice(1, 3).toLowerCase())
    .join(', ');
};

/* Start and end as one span. A batch is a range, and two date
   columns side by side read as two unrelated facts. */
export const formatSpan = (start, end) => {
  const s = start ? moment(start) : null;
  const e = end ? moment(end) : null;
  const sOk = s && s.isValid();
  const eOk = e && e.isValid();
  if (!sOk && !eOk) return '—';
  if (sOk && eOk) return `${s.format('DD MMM YYYY')} – ${e.format('DD MMM YYYY')}`;
  return (sOk ? s : e).format('DD MMM YYYY');
};

export const formatDate = (d) =>
  d && moment(d).isValid() ? moment(d).format('DD MMM YYYY') : '—';

/* The clock half of a stored datetime. Events keep the date and the
   time as separate fields, so the time one is only ever read for its
   hours and minutes. */
export const formatClock = (t) =>
  t && moment(t).isValid() ? moment(t).format('hh:mm A') : '—';

/* The affordance that says a row goes somewhere. A button rather
   than an anchor: it changes what this modal is showing, it does
   not navigate to a document, and a middle click on it should do
   nothing rather than open a broken tab. */
export const WaypointLink = ({ onClick, children }) => (
  <button type="button" className="wp-link" onClick={onClick}>
    {children}
  </button>
);
